export default "__VITE_ASSET__O$_xAjkB__"